import { GridFeatureMode } from '@mui/x-data-grid';
import { store } from 'app/store';
import { setExportDialogOpen } from 'common/components/exportDialog/exportDialogSlice';
import { FilterProps } from 'common/components/filter/FilterBar.types';
import { PaginationGridData } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { PaginationMode } from 'common/constants/paginationMode';
import { FetchExportDataFunction, FetchExportDataResult } from 'common/types/TypeDefs';

export const processFetchingExportData = async (
    signal: AbortSignal,
    paginationMode: GridFeatureMode,
    filter: FilterProps | undefined,
    paginationGridData: PaginationGridData | undefined,
    fetchExportData?: FetchExportDataFunction
): Promise<FetchExportDataResult>  => {
    store.dispatch(setExportDialogOpen(true));

    if(paginationMode === PaginationMode.Client){
        return {
            isClientSidePagination: true,
            isSuccessful: true
        };
    }

    const data = (await fetchExportData?.(signal, filter?.filters.keywords[0], paginationGridData?.sortModel)) ?? [];
    return {
        data: data,
        isSuccessful: true,
        isClientSidePagination: false
    };

};
